import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Foundation from "./sections/Foundation";
import Journey from "./sections/Journey";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Story />
      <Foundation />
      <Journey />
      <Footer />
    </div>;
}